import { IFixedPriceSaleNFTVariable } from './types';

export const DefaultFixedPriceSaleNFTVariable: IFixedPriceSaleNFTVariable = {
  pagination: {
    skip: 0,
    limit: 10,
  },
};
